import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { blockUserApi } from "functions/axios";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
    joinParts,
} from "components/detail";

export const ParentShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    학부모 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
            headerButtons={({ defaultButtons }) => (
                <>
                    {defaultButtons}
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "WITHDRAWN" });
                        }}
                    >
                        탈퇴
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "RESTRICTED_SEVEN_DAYS" });
                        }}
                    >
                        7일 정지
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            blockUserApi(record?.id, { status: "BAN" });
                        }}
                    >
                        영구정지
                    </Button>
                </>
            )}
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    학부모를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="로그인 Id" value={record?.loginId} />
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="별명(닉네임)" value={record?.nickName} />
                        <FieldItem
                            label="주소"
                            value={joinParts([record?.address, record?.detailAddress], "  ")}
                        />
                        <FieldItem label="전화번호" value={record?.phoneNumber} />
                        <FieldItem label="이메일주소" value={record?.emailAddress} />
                        <FieldItem
                            label="알림 확인 여부"
                            value={record?.readAlarm === true ? "예" : "아니오"}
                        />
                        <FieldItem label="관심 연령대" value={record?.interestAge} />
                        {/* 원본: <pre>{JSON.stringify(record?.theme, null, 2)}</pre> */}
                        <FieldItem
                            label="관심 주제"
                            span={2}
                            multiline
                            value={
                                record?.theme != null
                                    ? JSON.stringify(record.theme, null, 2)
                                    : undefined
                            }
                        />
                        <FieldItem
                            label="아이 목록"
                            value={
                                <RelatedLink
                                    to={`/children?filters[0][field]=parentId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=USER`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
